module.exports = __webpack_public_path__ + "img/img_boss_phone_img1.938aae42.png";